<template>
  <div class="otp-setup-container">
    <div class="otp-setup-content">
      <h1 class="otp-setup-title">账号绑定</h1>
      <p class="otp-setup-hint">
        为了完成注册，需要先下载 Microsoft Authenticator 应用，步骤如下：<br>
      </p>

      <p class="otp-setup-hint—list">
        1：请先下载 Authenticator<br>
      </p>
      <p class="otp-setup-hint—list">
        2：扫描下方二维码或右上角点击+，选择其他 -> 手动输入代码，自定义账户名称，密钥为下方显示的字符串，点击完成。<br>
      </p>
      <p class="otp-setup-hint—list">
        3：绑定完成后，输入app上显示的6位数字进行验证。
      </p>

      <!-- 二维码区域，居中显示在key上方 -->
      <div class="otp-setup-qr" v-if="qrDataUrl">
        <img :src="qrDataUrl" alt="QR Code" class="qr-img" />
      </div>
      <div class="otp-setup-qr" v-else-if="loading">
        <i class="el-icon-loading" style="font-size: 40px; color: #409EFF;"></i>
      </div>

      <div class="otp-setup-key">
        <span class="otp-setup-key-text">{{ setupKey }}</span>
        <el-button type="text" class="copy-btn" @click="copyKey">
          <i class="el-icon-document-copy"></i> 复制
        </el-button>
      </div>

      <div class="otp-message" v-if="errorMessage">
        <el-text type="danger">{{ errorMessage }}</el-text>
      </div>

      <el-button type="primary" class="otp-setup-next" @click="nextStep" :disabled="!setupKey">
        下一步
      </el-button>
    </div>
  </div>
</template>

<script>
const QRCode = require('qrcode')

export default {
  name: 'OtpSetup',
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    getMfaSecretUrl: {
      type: String,
      default: 'coupon-system/otp/getMfaSecret'
    },
    showBackBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      setupKey: '',
      qrDataUrl: '',
      loading: false,
      errorMessage: ''
    }
  },
  methods: {
    fetchMfaSecret() {
      const _this = this
      _this.loading = true
      _this.errorMessage = ''
      _this.$ajax({
        url: _this.getMfaSecretUrl,
        methods: 'POST',
        data: { userid: _this.userInfo ? _this.userInfo.id : '' },
        token: window.sessionStorage.getItem('token'),
        success: function(response) {
          _this.loading = false
          if (response.code === 0) {
            const data = response.data
            if (data) {
              _this.setupKey = data.totpSecret || ''
              if (data.totpQrUrl) {
                _this.generateQRCode(data.totpQrUrl)
              }
            }
          } else {
            _this.errorMessage = response.message || '获取MFA密钥失败'
          }
        },
        error: function() {
          _this.loading = false
          _this.errorMessage = '获取MFA密钥失败'
        }
      })
    },
    generateQRCode(url) {
      const _this = this
      QRCode.toDataURL(url, {
        width: 200,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      }, function(error, dataUrl) {
        if (error) {
          console.error('QR Code generation failed:', error)
        } else {
          _this.qrDataUrl = dataUrl
        }
      })
    },
    copyKey() {
      if (!this.setupKey) return
      navigator.clipboard.writeText(this.setupKey).then(() => {
        this.$message.success('Copied!')
      }).catch(() => {
        // fallback
        const textarea = document.createElement('textarea')
        textarea.value = this.setupKey
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('Copied!')
      })
    },
    nextStep() {
      this.$confirm(
        '请确认您已保存 Key 到本地。一旦进入下一步，此密钥将不再显示。如果丢失，您将需要重新注册账户。',
        '重要提醒',
        {
          confirmButtonText: '已保存，继续',
          cancelButtonText: '返回保存',
          type: 'warning'
        }
      ).then(() => {
        this.$emit('next-step')
      }).catch(() => {
        // 用户取消，不做任何操作
      })
    }
  },
  mounted() {
    this.fetchMfaSecret()
  }
}
</script>

<style scoped>
.otp-setup-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px;
}

.otp-setup-content {
  position: relative;
  width: 100%;
  max-width: 480px;
  text-align: center;
}

.otp-setup-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #303133;
}

.otp-setup-hint {
  font-size: 14px;
  color: #606266;
  /* margin: 0 0 24px 0; */
  line-height: 1.6;
  text-align: left;
}
.otp-setup-hint—list {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  text-align: left;
  padding-left: 27px;
  text-indent: -23px;
  margin: 0;
}

.otp-setup-qr {
  margin: 0 auto 24px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-img {
  width: 100px;
  height: 100px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
}

.otp-message {
  min-height: 24px;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-setup-key {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
}

.otp-setup-key-text {
  font-family: monospace;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  letter-spacing: 1px;
}

.copy-btn {
  padding: 8px 16px;
}

.otp-setup-next {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/otpSetup.vue